import { Small } from 'components/text';
import Image from 'next/future/image';
import { FC } from 'react';
import { HotelShortInfoType } from 'types/types';

interface IShortInfo {
  info: HotelShortInfoType;
}

const ShortInfo: FC<IShortInfo> = ({ info }) => {
  const { logo, ...textItems } = info;

  const {
    type,
    location_description,
    guest_rooms_count,
    opening,
    opened,
    last_refurbished,
    check_in_time,
    check_out_time,
  } = textItems;

  const renderLogoTextItem = (title: string, value: string | number) => {
    return (
      <div className="short-info__logo__infoText__container">
        <Small weight="demiBold" style={{ color: '#505050' }}>
          {title}
        </Small>
        <Small>{value}</Small>
      </div>
    );
  };
  const renderTextItem = (title: string, value: string | number) => {
    return (
      <div className="short-info__infoText__container">
        <Small
          className="short-info__infoText__title"
          weight="demiBold"
          style={{ color: '#505050' }}
        >
          {title}
        </Small>
        <Small>{value}</Small>
      </div>
    );
  };

  if (logo) {
    return (
      <div className="short-info__logo__infoContainer">
        <div className="short-info__logo__container">
          <div className="short-info__logo__box">
            <Image
              src={logo}
              alt={''}
              width={2000}
              height={1545}
              className="short-info__logo__img"
            />
          </div>
        </div>
        <div className="short-info__logo__infoText">
          {type && renderLogoTextItem('Type', type)}
          {location_description &&
            renderLogoTextItem('Location', location_description)}
          {guest_rooms_count && renderLogoTextItem('Rooms', guest_rooms_count)}
          {opening && renderLogoTextItem('Opening', opening)}
          {opened && renderLogoTextItem('Opened', opened)}
          {last_refurbished &&
            renderLogoTextItem('Refurbished', last_refurbished)}
          {check_in_time && renderLogoTextItem('Check in', check_in_time)}
          {check_out_time && renderLogoTextItem('Check out', check_out_time)}
        </div>
      </div>
    );
  }

  return (
    <div className="short-info__container">
      {type && renderTextItem('Type', type)}
      {location_description && renderTextItem('Location', location_description)}
      {guest_rooms_count && renderTextItem('Rooms', guest_rooms_count)}
      {opening && renderTextItem('Opening', opening)}
      {opened && renderTextItem('Opened', opened)}
      {last_refurbished && renderTextItem('Refurbished', last_refurbished)}
      {check_in_time && renderTextItem('Check in', check_in_time)}
      {check_out_time && renderTextItem('Check out', check_out_time)}
    </div>
  );
};
export default ShortInfo;
